module.exports = __webpack_public_path__ + "aab920e04211577da140c01f1f39adff.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 2248
 ** module chunks = 73
 **/